import { appAxios } from '../libs/axios/appAxios';
import { setFormData } from '../utils/formUtil';

const RECOMMEND_ENDPOINT = '/dcfront/recommend/ajax/recommendPanel/';

/**
 * レコメンドデータ取得
 * @param data 送信するデータオブジェクト
 */
export function postRecommend(data: Record<string, string>) {
  const formData = setFormData(data);
  return appAxios.post(RECOMMEND_ENDPOINT, formData);
}
